import { Injectable, Injector } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { CoreParameterModel, ILightWeightObjectCollection } from '@fi-shared/models';
import { IRoleModel, RoleModel } from '../role.model';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@Injectable()
export class RoleService {
    constructor(
        private fiBackend: FiBackendService,
        private userDataService: FiUserDataService,
        private fiLoading: LoadingService,
        private injector: Injector,
    ) {}

    getRole(id: number, isViewMode: boolean = true) {
        return new Promise<RoleModel>((resolve, reject) => {
            if (id > 0) {
                this.fiBackend
                    .fetchData<IRoleModel>(`core/role/GetRole/${id}?isViewMode=${isViewMode}`)
                    .then((response) => {
                        resolve(new RoleModel(this.userDataService.applicationLanguage, response, this.injector));
                    }, reject);
            } else {
                resolve(new RoleModel(this.userDataService.applicationLanguage, undefined, this.injector));
            }
        });
    }

    getLightWeightRoles() {
        return this.fiBackend.fetchData('Core/Role/GetLightWeightRoles/');
    }

    saveRole(role: RoleModel) {
        return this.fiBackend.fetchDataPost<number>('core/role/SaveRole', role);
    }

    getRolesListData(parameter: IItemsListParameterBase) {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<any>>('Core/Role/GetRolesListData', parameter);
    }

    getRoles(roleParameterApiModel: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<RoleModel[]>('Core/Role/GetRoles', roleParameterApiModel);
    }

    GetRolesCount(roleParameterApiModel: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<number>('Core/Role/GetRolesCount', roleParameterApiModel);
    }

    GetLightWeightObjectsForLocalSearch(roleParameterApiModel: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<ILightWeightObjectCollection>(
            'Core/Role/GetLightWeightObjectsForLocalSearch',
            roleParameterApiModel,
        );
    }

    getRoleIdsWithManageAccess() {
        return this.fiBackend.fetchData<number[]>('Core/Role/GetRoleIdsWithManageAccess');
    }

    shareContent(data) {
        return this.fiBackend.fetchDataPost('Core/Role/ShareContent', data);
    }

    deleteRoles(roleIdsToDelete: number[]) {
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost('Core/Role/DeleteRoles', roleIdsToDelete));
    }
}
